import axios from 'axios';

let axiosInstance = axios.create({
    baseURL: `https://${process.env.VUE_APP_ENDPOINT_SERVICES_PROXY}`,
});

async function log(level, message, trace) {
    return await axiosInstance.post('/api/services-new/logger/log', {
        app: 'content-admin',
        level: level,
        message: message,
        trace: trace
    });
}

const info = (message, trace = null) => {
    return log('info', message, trace);
};

const warning = (message, trace = null) => {
    return log('warning', message, trace);
};

const error = (message, trace = null) => {
    return log('error', message, trace);
};

export default { info, warning, error };
